const value = {
    project: 'Project',
    myProjects: 'My projects',
    addProject: 'Add project',
    system: 'System',
    projectIsEmpty: 'Project is empty',
    noResults: 'No results',
    noProjects: 'No projects',
    youAreNotAparticipantInTheProjects: 'You are not a project participant',
    noTeamForProject: 'No team for project',
    loadMore: 'Load more',
    team: 'Team',
    teamDescription:
      'Invite participants using the link. Registered users will be able to join the project and select a role from the list.',
    invitationLink: 'Invitation link',
    invitationLinkHelperText: 'Select the roles that users will receive using the new link',
    fullName: 'Full name',
    projectRole: 'Role',
    projectRoleDescription:
      'After saving, an invitation link will appear on the project page. Any registered user will be able to join the project and select a role using it.',
    empty: '',
    addSystem: 'Add system',
    editProject: 'Edit project',
    noEstablishedSystems: 'Your projects do not yet have established AS',
    requirements: 'Requirements',
    moveSystem: 'Move system',
    copySystem: 'Copy system',
    training: 'Training',
    trainingPreview: 'Training preview',
    profile: 'Profile',
    requirementsPreview: 'Requirements preview',
    changeHistory: 'Change history',
    downloadAsProfile: 'Download system profile',
    typeOfExecutors: 'Type of executors',
    typeOfExecutorsHelperText:
      'Depending on the selected value, some additional columns, fields or requirements will be hidden in the generated set of requirements. For example, for external developers',
    noCharacteristics: 'No characteristics',
    totalProjects: 'projects',
    totalSystems: 'systems',
    requirementsCollection: 'Requirements collection',
    deleteProject: 'Delete project',
    deleteProjectMessage: 'Are you shure you want to delete project',
    userProjectTable: {
      systems: 'Systems',
      requirements: 'Requirements',
      lastActivity: 'Last activity',
      actions: 'Actions',
      project: 'Project',
      risks: 'Risks',
    },
    youLeftProject: 'You have left the project',
    leaveProject: 'Leave the project',
    returnToProject: 'Return',
    selectRole: 'Select a role',
  };

export default value;
